import HelpPopOver from "@shared/ui/HelpPopover";
import { Divider, Space, Typography } from "antd";

const { Title, Text } = Typography;

interface Props {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  value: string;
  infoDesc?: string;
}

export function PerformanceTile({
  title,
  value,
  description,
  icon,
  infoDesc,
}: Props) {
  return (
    <div>
      <Space size="small" style={{ alignItems: "center" }}>
        {icon}
        <Title level={4} style={{ margin: 0, marginTop: 0 }}>
          {value}
        </Title>
      </Space>
      <Space style={{ display: "flex", marginTop: 10 }}>
        {title && <Text type="secondary">{title}</Text>}

        {infoDesc && <HelpPopOver customText={infoDesc} />}
      </Space>

      {description && (
        <>
          <Divider style={{ margin: "10px 0" }} />
          <Text type="secondary">{description}</Text>
        </>
      )}
    </div>
  );
}
